import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const InvalidBarcodePopup = ({ onClose, validate, barcode }) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup
             id="receivesets-invalidbarcode-popup"
                title={t('receiveSets.ReceiveSetsLoc.AddSetsLists.setNotFound')}
                onClose={onClose}
                img={AlertCircleOutline}
                id={'receiveSets-invalidBarcodePopup-popup'}
            >
                <UnsavedChangesDiv divHeight={'140px'}>
                    <Text
                    // flexGrow={'1'}
                    // height={'auto'}
                    // font={'14px Avenir Next World'}
                    // lineHeight={'20px'}
                    >
                        {validate
                            ? `${t(
                                  'templates.addProductMethods.productTemplates.productTemplates.set'
                              )} ${validate} ${t(
                                  'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg6'
                              )}`
                            : `${t(
                                  'receiveSets.ReceiveSubmit.ReceivedSets.barcode'
                              )} ${barcode ? barcode : ''} ${t(
                                  'receiveSets.ReceiveSetsLoc.AddSetsLists.doesntReturnAnyValidSetsWithinMyCase'
                              )}`}
                    </Text>
                    <DesktopWrap flexDirection="row-reverse">
                        <Button
                        id={'receiveSets-notifications-invalid-barcode-popup-ok-button'}
                            show={true}
                            //cancel={true}
                            variant={ButtonStyles?.cancel}
                            width={'100px'}
                            height={'38px'}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t('orders.orderListFilters.closeButton')}
                            </div>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default InvalidBarcodePopup;
